var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"height":"auto","min-height":"100vh"}},[(_vm.progress)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }